const provinces = [
  { name: 'Ontario', value: 'ON' },
  { name: 'Quebec', value: 'QC' },
  { name: 'Nova Scotia', value: 'NS' },
  { name: 'New Brunswick', value: 'NB' },
  { name: 'Manitoba', value: 'MB' },
  { name: 'British Columbia', value: 'BC' },
  { name: 'Prince Edward Island', value: 'PE' },
  { name: 'Saskatchewan', value: 'SK' },
  { name: 'Alberta', value: 'AB' },
  { name: 'Newfoundland and Labrador', value: 'NL' },
]

export default provinces
